import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';
import { useDashboardData } from '../../state/DashboardDataContext.jsx';
import { useFreePreview } from '../../contexts/FreePreviewContext.jsx';
import { freePublishingState } from '../../lib/freePublishing.js';
import { CreatePost } from '../../screens/CreatePost.jsx';

export default function FreePublishingEditorRoute({ children }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const dash = useDashboardData();
  const preview = useFreePreview();
  const { id } = useParams();
  const location = useLocation();
  const entitlements = dash.entitlements || preview.entitlements;
  const capability = freePublishingState(dash.entitlementsError ? null : entitlements);
  // Keep a Free editor in its guarded lane when an entitlement refresh fails.
  // Falling through to the legacy compose mutation would lose this boundary.
  const scope = `${user?.id}:${id || 'new'}:${location.search}`;
  const previous = useRef({ scope, capability });
  if (previous.current.scope !== scope) previous.current = { scope, capability };
  if (capability) previous.current.capability = capability;
  const manualCapability = capability || previous.current.capability;
  if (!manualCapability && entitlements?.freePublishing?.active === true) return <p role="alert">{t('freePublishing.accessChanged')}</p>;
  if (!manualCapability) return children;
  return <CreatePost key={scope} manualDraftId={id} freePublishing={manualCapability} freeAccessAvailable={Boolean(capability)} />;
}
